import PropTypes from 'prop-types';

import AddContentObjectContainer from '../../pages/AddContentObject/AddContentObjectContainer';
import EditMediaContainer from '../../pages/EditMedia/EditMediaContainer';

/**
 * @emits FlotiqPlugins."flotiq.form.relation::after-submit"
 */
const EditObjectContentModal = ({
  contentTypeName,
  id,
  onSubmit,
  testId = '',
}) => {
  const isMedia = contentTypeName === '_media';

  return (
    <>
      {isMedia ? (
        <EditMediaContainer id={id} onSubmit={onSubmit} testId={testId} />
      ) : (
        <AddContentObjectContainer
          contentTypeName={contentTypeName}
          id={id}
          onSubmit={onSubmit}
          testId={testId}
        />
      )}
    </>
  );
};

export default EditObjectContentModal;

EditObjectContentModal.propTypes = {
  /**
   * Content object type name
   */
  contentTypeName: PropTypes.string.isRequired,
  /**
   * Content object id
   */
  id: PropTypes.string,
  /**
   * Edit modal test id
   */
  testId: PropTypes.string,
  /**
   * Should the form have switches for enabling fields
   */
  isPatchable: PropTypes.bool,
};
